<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">Export data Konsumen Dengan Lat Long</div>
      <div v-if="loading == true">
        <loading></loading>
      </div>
      <div class="card-body" v-if="loading == false">
        <div class="col-lg-3">
          <b-form-group label-for="customer_status" label="Status Konsumen">
            <model-select
              id="customer_status"
              :options="listCustStatus"
              v-model="custStatus"
              placeholder="-- Harap pilih salah satu --"
            ></model-select>
          </b-form-group>
        </div>
        <div class="col-lg-3">
          <b-button
            type="button"
            size="sm"
            variant="primary"
            @click="downloadfile"
          >
            <i class="fa fa-save"></i> Download
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import loading from "@/templates/Loading.vue";
import { ModelSelect } from "vue-search-select";

export default {
  name: "report_data_customer",
  components: {
    loading,
    ModelSelect,
  },
  data() {
    return {
      loading: false,
      custStatus: null,
      listCustStatus: [],
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.getDropdown();
      this.loading = false;
    },
    downloadfile: function () {
      if (confirm("Are You Sure?")) {
        if (this.custStatus === null) {
          alert("Please Select Customer Code");
        } else {
          this.loading = true;
          this.axios({
            url: "web/export/customer/lat-long/"+this.custStatus,
            method: "GET",
            responseType: "blob",
          })
            .then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "data_customer.xlsx");
              document.body.appendChild(link);
              link.click();
            })
            .catch((error) => {
              if (error.response.status === 401) {
                this.expired(error, "");
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
    getDropdown: function () {
      this.axios
        .get("web/dropdown/customer-status")
        .then((response) => {
          this.listCustStatus = response.data.data;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
</style>
